import { Text, View, useColorScheme } from 'react-native';
import React, { Suspense, lazy, memo, useState } from 'react';
import DefaultScreen from '@components/Global/DefaultScreenView';
import Button from '@components/UI/Button/Button';
import { useNavigation } from '@react-navigation/native';
import DropDownView from '@components/Global/DropDownView';
import MenuIconCard from '@components/Global/MenuIconCard';
import { useTranslation } from 'react-i18next';
import { XStack } from 'tamagui';


const AnimatedLottieView = lazy(() => import('@utils/lottieAnimation'));

const LazyLottieView = (props) => (
  <Suspense fallback={<View />}>
    <AnimatedLottieView {...props} />
  </Suspense>
);


const ProjectMenu = ({ navigation }) => {
  const { t } = useTranslation();

  return (
    <DefaultScreen style={{ backgroundColor: "transparent", left: 3 }}>
      <XStack gap={20} columnGap={20} rowGap={5} flexWrap="wrap" style={{ paddingBottom: 150, alignSelf: 'stretch', flexDirection: 'row', flexWrap: 'wrap' }}>
        <MenuIconCard pressFunction={() => navigation.navigate('ProjectsList')} subtitle={`${t('BrowseProjectsSub')}`} cardTitle={`${t('BrowseProjects')}`}>
          <LazyLottieView source={require('@assets/animations/magnifExample.json')} loop={true} style={{ width: '110%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard pressFunction={() => navigation.navigate('ProjectFavourites')} subtitle={`${t('FavouriteProjectsSub')}`} cardTitle={`${t('FavouriteProjects')}`}>
          <LazyLottieView source={require('@assets/animations/star.json')} loop={true} style={{ width: '110%', height: 70, justifyContent: 'center', alignSelf: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard comingSoon pressFunction={() => alert('Coming Soon!')} subtitle={`${t('ProjectTemplatesSub')}`} cardTitle={`${t('ProjectTemplates')}`}>
          <LazyLottieView source={require('@assets/animations/42404-add-document.json')} loop={true} style={{ width: '110%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
        <MenuIconCard pressFunction={() => navigation.navigate("CompletedProjects")} subtitle={`${t('CompletedProjectsSub')}`} cardTitle={`${t('CompletedProjects')}`}>
          <LazyLottieView source={require('@assets/animations/105897-saved-folder.json')} loop={true} style={{ width: '110%', height: 70, alignSelf: 'center', justifyContent: 'center' }} autoPlay />
        </MenuIconCard>
      </XStack>
    </DefaultScreen >
  )
}
export default memo(ProjectMenu);